import { OnboardingHOC } from 'testania';
import { compose } from 'redux';
import React from 'react';

import sendAnalyticsWithEventLabel from 'helpers/analytic/sendAnalyticsWithEventLabel';

import ObSocialProofContainer from 'containers/onboarding/ObSocialProof';

import mainImage from 'assets/img/socialProof/18-25.webp';

import { ICommonPageProps } from 'types/pages/onboardingPages/commonTypes';

import OnboardingAnalytics from 'hocs/Analytic/Onboarding';

const ObSocialProofConf = ({ toNextPage, history, pageInfo }: ICommonPageProps) => {
    const img = pageInfo?.config?.imageProof.includes('web.appscdn.io') ? pageInfo?.config?.imageProof : mainImage;
    const usersNumber = pageInfo?.config?.usersNumber ?? '55';

    const handleContinueClick = () => {
        sendAnalyticsWithEventLabel({
            url: history.location.pathname,
            eventValue: 'continue',
        });

        toNextPage();
    };

    return <ObSocialProofContainer toNextPage={handleContinueClick} users={usersNumber} img={img} withoutMaxWidth />;
};

export default compose<typeof ObSocialProofConf>(OnboardingHOC, OnboardingAnalytics)(ObSocialProofConf);
